module.exports = require("@agm/core/services/managers/circle-manager");